import { SimpleForm } from 'react-admin';
import _ from 'lodash';
import FormContent from './FormContent';
import { AdverseEditNoteProps } from './types';

const AdverseEditNote = (props: AdverseEditNoteProps) => {
  return (
    <SimpleForm mode="onChange" reValidateMode="onChange" toolbar={false}>
      <FormContent {...props} />
    </SimpleForm>
  );
};

export default AdverseEditNote;
